import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getExchangeStatus = createAsyncThunk(
  '/getExchangeStatus',
  async () => {
    const response = await axios.get('/GetExChangeStatus');
    return response.data;
  }
);

export const getExchangeTasksData = createAsyncThunk(
  '/getExchangeTasksData',
  async ids => {
    const response = await axios.get(
      `/GetExchangeTasksData/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}/${ids[4]}/${ids[5]}/${ids[6]}/${ids[7]}`

    );
    return response.data;
  }
);
export const getConsumerWorkOrder = createAsyncThunk(
  '/getConsumerWorkOrder',
  async (WorkOrderId) => {
    const response = await axios.get(`/GetConsumerWorkOrderForExchange/${WorkOrderId}`);
    return response.data;
  }
);
export const getChangeReason = createAsyncThunk(
  '/getChangeReason',
  async () => {
    const response = await axios.get('/GetChangeReason');
    return response.data;
  }
);
export const setExchange = createAsyncThunk('/setExchange', async (id) => {
  const response = await axios.post('/SetExchange', id, {
    timeout: 120000
  });
  return response.data;
});
export const setExchangePdf = createAsyncThunk('/setExchangePdf', async id => {
  const response = await axios.post(`/SetExchangePdf`, id);
  return response.data;
});
export const getChangeReasonDetail = createAsyncThunk(
  '/GetChangeReasonDetailWithValue',
  async id => {
    const response = await axios.get(`/GetChangeReasonDetailWithValue/${id}`);
    return response.data;
  }
);
export const getExchangeTypeExtendList = createAsyncThunk(
  '/GetExchangeTypeExtendList',
  async () => {
    const response = await axios.get('/GetExchangeTypeExtendList');

    return response.data;
  }
);

export const getExchangeRejectReasons = createAsyncThunk(
  '/getExchangeRejectReasons',
  async () => {
    const response = await axios.get('/GetExchangeRejectReasons');

    return response.data;
  }
);
export const getSiriusWorkOrderHistory = createAsyncThunk(
  '/getSiriusWorkOrderHistory',
  async id => {
    const response = await axios.get(`/GetSiriusWorkOrderHistory/${id}`);

    return response.data;
  }
);

export const getExchangeAcceptReasons = createAsyncThunk(
  '/getExchangeAcceptReasons',
  async () => {
    const response = await axios.get('/GetExchangeAcceptReasons');

    return response.data;
  }
);

export const getExchangeStorageLocation = createAsyncThunk(
  '/getExchangeStorageLocation',
  async () => {
    const response = await axios.get('/GetExchangeStorageLocation');
    return response.data;
  }
);

export const getExchangeFormByWorkOrder = createAsyncThunk(
  '/getExchangeFormByWorkOrder',
  async workCaseId => {
    const response = await axios.get(`/GetExchangeFormByWorkOrder/${workCaseId}`);
    return response.data;
  }
)

const productExchangeSlice = createSlice({
  name: 'productExchange',
  initialState: {
    loading: false,
    error: '',
    ExchangeStatus: [],
    ExchangeReason: [],
    ExchangeSaveData: [],
    ReasonDetail: [],
    ConsumerWorkOrder: [],
    WorkOrderInformation: [],
    ExchangeTypeExtendList: [],
    ExchangeRejectReasons: [],
    ExchangeAcceptReasons: [],
    ExchangeStorageLocations: [],
    WorkOrderHistory: [],
  },
  reducers: {},
  extraReducers: {
    [getExchangeTypeExtendList.pending]: state => {
      state.loading = true;
    },
    [getExchangeTypeExtendList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeTypeExtendList.fulfilled]: (state, action) => {
      state.ExchangeTypeExtendList = action.payload;
      state.loading = false;
    },
    [getExchangeStatus.pending]: state => {
      state.loading = true;
    },
    [getExchangeStatus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeStatus.fulfilled]: (state, action) => {
      state.ExchangeStatus = action.payload;
      state.loading = false;
    },
    [getChangeReason.pending]: state => {
      state.loading = true;
    },
    [getChangeReason.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getChangeReason.fulfilled]: (state, action) => {
      state.ExchangeReason = action.payload;
      state.loading = false;
    },
    [getExchangeTasksData.pending]: state => {
      state.loading = true;
    },
    [getExchangeTasksData.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeTasksData.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },
    [getConsumerWorkOrder.pending]: state => {
      state.loading = true;
    },
    [getConsumerWorkOrder.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerWorkOrder.fulfilled]: (state, action) => {
      state.ConsumerWorkOrder = action.payload;
      state.loading = false;
    },

    [getChangeReasonDetail.pending]: state => {
      state.loading = true;
    },
    [getChangeReasonDetail.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getChangeReasonDetail.fulfilled]: (state, action) => {
      state.ReasonDetail = action.payload;
      state.loading = false;
    },
    [getExchangeRejectReasons.pending]: state => {
      state.loading = true;
    },
    [getExchangeRejectReasons.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeRejectReasons.fulfilled]: (state, action) => {
      state.ExchangeRejectReasons = action.payload;
      state.loading = false;
    },
    [getExchangeAcceptReasons.pending]: state => {
      state.loading = true;
    },
    [getExchangeAcceptReasons.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeAcceptReasons.fulfilled]: (state, action) => {
      state.ExchangeAcceptReasons = action.payload;
      state.loading = false;
    },
    [getSiriusWorkOrderHistory.pending]: state => {
      state.loading = true;
    },
    [getSiriusWorkOrderHistory.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSiriusWorkOrderHistory.fulfilled]: (state, action) => {
      state.WorkOrderHistory = action.payload;
      state.loading = false;
    },
    [getExchangeStorageLocation.pending]: state => {
      state.loading = true;
    },
    [getExchangeStorageLocation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeStorageLocation.fulfilled]: (state, action) => {
      state.ExchangeStorageLocations = action.payload;
      state.loading = false;
    },
    [setExchange.pending]: (state) => {
      state.loading = true;
    },
    [setExchange.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setExchange.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setExchangePdf.pending]: (state) => {
      state.loading = true;
    },
    [setExchangePdf.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setExchangePdf.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    }
  }
});

export const productExchangeActions = productExchangeSlice.actions;
export default productExchangeSlice;
